import $ from 'jquery';
import 'slick-carousel';

const defaults = {
  speed: 500,
  dots: false,
  arrows: false,
  fade: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        dots: true,
        arrows: false,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

/**
 * Home Timeline Slider Constructor
 */
function Slider(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = Object.assign(defaults, options);
  this.$gallery = this.build();
  this.ready();
}

Slider.prototype = {
  build() {
    return this.$element.slick(this.settings);
  },
  ready() {
    this.$element.addClass('ready');
    this.$element.closest('.block').addClass('ready');
  },
};

export default Slider;
